import SvgIcon, { SvgIconProps } from "@mui/material/SvgIcon";

interface CustomSvgIconProps extends SvgIconProps {
  hideVector?: boolean;
}

export const SwitchThumbVectorIcon = ({
  hideVector,
  ...props
}: CustomSvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="100%" height="100%" rx="50%" fill="white" />
    {!hideVector && (
      <g>
        <path
          d="M15.2857 11.5H6.71429C6.32143 11.5 6 11.1625 6 10.75C6 10.3375 6.32143 10 6.71429 10H15.2857C15.6786 10 16 10.3375 16 10.75C16 11.1625 15.6786 11.5 15.2857 11.5Z"
          fill={props.color}
        />
      </g>
    )}
  </SvgIcon>
);
